Vue.component('newsletter-form', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            submitting: false,
            submitted: false,
            error: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        //
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        /**
         * Handles submit event of the form.
         *
         * @param {Event}
         * @returns {Void}
         */
        onSubmit(event) {
            const form = event.currentTarget;
            axios.post(form.action, new FormData(form))
                .then((response) => {
                    this.submitting = false;

                    if (response.data.success) {
                        this.error = null;
                        this.submitted = true;
                        return;
                    }

                    // TODO: Handle error message
                    this.error = response.data.errorCode;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/newsletter-form.js